angular.module('impactx.rfx').controller('RFXNewRoundDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    RFXNewRoundDialogCtrl
]);

function RFXNewRoundDialogCtrl($scope, dataGen, $mdDialog, TranslationService) {
    var ctrl = this;

    function getData() {
        dataGen.getData($scope, {rfqhId: ctrl.rfqhId}, '/rfx/buyer/newround').then(function () {
            if ($scope.data) {
                $scope.trns.save = TranslationService.get('save');
                $scope.trns.cancel = TranslationService.get('abort');
            }
        });
    }

    ctrl.save = function() {
        $mdDialog.hide($scope.data);
    }

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.disableSave = function () {
        if ($scope.data && $scope.data.suppliers) {
            return $scope.data.suppliers.filter(function (entry) {
                return entry.selected;
            }).length < $scope.data.minNumSuppliers;
        }
        return true;
    }

    getData();
}